import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "messages" }

import { capitalize } from '@/util/string.util';
import { ref, watch, PropType, computed } from 'vue';
import { MdEditor, ToolbarNames } from 'md-editor-v3';
import 'md-editor-v3/lib/style.css';
import MediaToolbar from '@/components/common/MediaToolbar.vue';
import LinkToolbar from '@/components/common/LinkToolbar.vue';
import { Media } from '@/models/media.model';

type ValidationResult = string | boolean;
type ValidationRule$1 =
  | ValidationResult
  | PromiseLike<ValidationResult>
  | ((value: string) => ValidationResult)
  | ((value: string) => PromiseLike<ValidationResult>);


export default /*@__PURE__*/_defineComponent({
  __name: 'RichTextField',
  props: {
  label: { type: String, default: () => 'Label' },
  height: { type: Number, default: () => 400 },
  hint: { type: String, default: () => '' },
  rules: {
    type: Array as PropType<ValidationRule$1[]>,
    default: () => [],
  },
  disabled: { type: Boolean, default: () => false },
  modelValue: { type: String, required: true, default: () => '' },
  media: { type: Array as PropType<Media[]>, default: () => [] },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const text = ref<string>(props.modelValue || '');

const toolbars: ToolbarNames[] = [
  'bold',
  'underline',
  'italic',
  'strikeThrough',
  '-',
  'unorderedList',
  'orderedList',
  '-',
  'title',
  'image',
  '-',
  0, // first custom toolbar
  1,
];

const emit = __emit;

const errors = computed<boolean | string>(() => {
  const errs = props.rules?.map((r) => r(text.value));

  if (errs.some((v) => typeof v === 'string')) {
    return errs.map((v) => (typeof v === 'string' ? v : '')).join('');
  }
  return true;
});

function update(v: string) {
  text.value = v;
  emit('update:modelValue', text.value);
  emit('change');
  showHint.value = true;
}

watch(
  () => props.modelValue,
  () => {
    text.value = props.modelValue || '';
  },
  { deep: true },
);

const showHint = ref<boolean>(false);

return (_ctx: any,_cache: any) => {
  const _component_v_messages = _resolveComponent("v-messages")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["rich-text-field", {
      'rich-text-field-disabled': __props.disabled,
      'rich-text-field-invalid': !__props.disabled && errors.value !== true,
    }])
    }, [
      _createElementVNode("label", null, _toDisplayString(_unref(capitalize)(__props.label)), 1),
      _createVNode(_unref(MdEditor), {
        modelValue: text.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
        language: "en-US",
        disabled: __props.disabled,
        toolbars: __props.disabled ? [] : toolbars,
        toolbarsExclude: ['image'],
        style: _normalizeStyle({ height: `${__props.height}px` }),
        onChange: _cache[1] || (_cache[1] = (v) => update(v))
      }, {
        defToolbars: _withCtx(() => [
          _createVNode(MediaToolbar, { media: __props.media }, null, 8, ["media"]),
          _createVNode(LinkToolbar)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled", "toolbars", "style"])
    ], 2),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_messages, {
        active: showHint.value,
        transition: "slide-y-transition",
        messages: [__props.hint]
      }, null, 8, ["active", "messages"]),
      _createVNode(_component_v_messages, {
        color: "#a70000",
        active: !__props.disabled && errors.value !== true,
        transition: "slide-y-transition",
        messages: [errors.value as string]
      }, null, 8, ["active", "messages"])
    ])
  ], 64))
}
}

})